import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { XEditorLayout, XTimerButton } from '@/components';
import { computed, reactive, ref } from 'vue';
import { modal } from '@/share/components';
import { validate } from '@/utils';

import { useComponentModalInstance } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/share/hooks/common/index.js';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'set-author-email-form',
  setup(__props, {
    expose: __expose
  }) {
    const modalInst = useComponentModalInstance();
    const formRef = ref();
    const formData = reactive({
      password: '',
      // 用户密码，只有用户密码输入正确才能修改手机号码
      email: '',
      verifyCode: '',
      // 验证码
      codeId: '' // 验证码ID
    });
    const formRules = reactive({
      password: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }],
      email: [{
        required: true,
        message: '请输入邮箱地址',
        trigger: 'blur'
      }, {
        trigger: 'blur',
        validator: (_, value) => {
          if (!validate.isEmail(value)) {
            return Promise.reject(new Error('邮箱地址格式不正确'));
          }
          return Promise.resolve();
        }
      }],
      verifyCode: [{
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      }]
    });
    const {
      runAsync: sendEmailVerifyCode
    } = fetchApi('common.notice.sendEmailVerifyCode', {
      showError: false
    });
    const {
      runAsync: setEmail
    } = fetchApi('user.setCurrentEmail', {
      showError: false
    });
    const emailIsValidate = computed(() => {
      return formData.email && validate.isEmail(formData.email);
    });
    const sendTitleFormat = time => {
      return `${time}后重发`;
    };
    const handleSendVerifyCode = async () => {
      if (!emailIsValidate.value) return;
      const {
        error,
        codeId,
        info = ''
      } = await sendEmailVerifyCode({
        email: formData.email
      });
      if (error) {
        modal.notification.error(error, '发送验证码失败');
        return;
      }
      formData.codeId = codeId;
      if (info) {
        modal.notification.success(info, '发送验证码成功');
      }
      modalInst.setConfirmButton({
        disabled: false
      });
    };
    const onOk = async () => {
      const valid = await formRef.value.validate();
      if (!valid) return {
        error: '表单验证失败'
      };
      const {
        error,
        email
      } = await setEmail({
        ...formData
      });
      if (error) {
        modal.notification.error(error, '修改邮箱失败');
        return {
          error
        };
      }
      return {
        email
      };
    };
    const onCancel = () => {};
    __expose({
      confirmListener: onOk,
      cancelListener: onCancel
    });
    return (_ctx, _cache) => {
      const _component_a_input_password = _resolveComponent("a-input-password");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      return _openBlock(), _createBlock(_unref(XEditorLayout), {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: formRules
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "密码",
          name: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input_password, {
            value: formData.password,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.password = $event),
            placeholder: "请输入密码"
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "邮箱",
          name: "email"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: formData.email,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.email = $event),
            placeholder: "请输入邮箱地址"
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "验证码",
          name: "verifyCode"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: formData.verifyCode,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.verifyCode = $event),
            placeholder: "请输入验证码"
          }, {
            addonAfter: _withCtx(() => [_createVNode(_unref(XTimerButton), {
              type: "link",
              disabled: !emailIsValidate.value,
              title: "获取验证码",
              "max-sec": 180,
              "timer-title-format": sendTitleFormat,
              onClick: handleSendVerifyCode
            }, null, 8, ["disabled"])]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
};